<template>
  <div id="table">
    <div class="table-container">
      <div class="header">
        <h3>{{ title }}</h3>
        <button-component
          :data="{}"
          :label="openAccordion ? 'Abrir' : 'Fechar'"
          :type="'accordion'"
          :size="'max'"
          :withIcon="true"
          :iconName="openAccordion ? 'icon-arrow-1-down' : 'icon-arrow-1-up'"
          :funcionInput="onOpenAccordion"
          @functionOutput="getFunctionOpenAccordion($event)"
        />
      </div>
      <div v-if="!openAccordion" class="body">
        <div class="table-header">
          <div v-for="column in columns" :key="column.field" :style="`${columnSize} ${column.style}`" class="table-header-item">
            {{column.header}}
          </div>
        </div>
        <div class="table-body">
          <template v-if="data">
            <div v-if="!data.length" class="no-items">
              Não existem itens a serem mostrados
            </div>
          </template>
          <template v-for="item in data">
            <div class="table-content" :class="item.id === active ? 'active' : ''" :key="item.id">
              <div v-for="column in columns" :key="column.field" :style="`${columnSize} ${column.style}`" class="table-body-item">
                <router-link v-if="column.link" :to="{ name: column.linkName, params: { txid: item[column.linkParams] }}">
                  <span v-if="column.dataType === 'text'" v-b-tooltip.hover :title="item[column.field]" :class="column.class" class="truncate" :style="column.field === 'buyerName' ? 'padding-right: 8px' : ''">{{ item[column.field] }}</span><span v-if="column.field === 'buyerName' && column.rating" class="buyer-rating">{{item.rating}}</span>
                  <span v-if="column.dataType === 'id'" v-b-tooltip.hover :title="item[column.field] | numeral('00000')" :class="column.class" class="truncate"><strong>#{{ item[column.field] | numeral('00000') }}</strong></span>
                  <span v-if="column.dataType === 'number'" v-b-tooltip.hover :title="item[column.field] | numeral('0,0.00')" :class="column.class" class="truncate">{{ item[column.field] | numeral('0,0.00') }}</span>
                  <span v-if="column.dataType === 'date'" v-b-tooltip.hover :title="item[column.field] | moment-date-year-hour-min" :class="column.class" class="truncate">{{ item[column.field] | moment-date-year-hour-min }}</span>
                  <span v-if="column.dataType === 'currency'" v-b-tooltip.hover :title="item[column.field] | numeral('0,0.00')" :class="column.class" class="truncate">R${{ item[column.field] | numeral('0,0.00') }}</span>
                  <span v-if="column.dataType === 'percentage'" v-b-tooltip.hover :title="item[column.field] | numeral('0,0.00')" :class="column.class" class="truncate">{{ item[column.field] | numeral('0,0.00') }}%</span>
                  <span v-if="column.dataType === 'phone'" v-b-tooltip.hover :title="item[column.field] | filterPhone" :class="column.class" class="truncate">{{ item[column.field] | filterPhone }}</span>
                  <span v-if="column.dataType === 'cnpj'" v-b-tooltip.hover :title="item[column.field] | filterCNPJ" :class="column.class" class="truncate">{{ item[column.field] | filterCNPJ }}</span>
                  <span v-if="column.dataType === 'cpf'" v-b-tooltip.hover :title="item[column.field] | filterCPF" :class="column.class" class="truncate">{{ item[column.field] | filterCPF }}</span>
                </router-link>

                <template v-else>
                  <span v-if="column.dataType === 'text'" v-b-tooltip.hover :title="item[column.field]" :class="column.class" class="truncate" :style="column.field === 'buyerName' ? 'padding-right: 8px' : ''">{{ item[column.field] }}</span><span v-if="column.field === 'buyerName' && column.rating" class="buyer-rating">{{item.rating}}</span>
                  <span v-if="column.dataType === 'id'" v-b-tooltip.hover :title="item[column.field] | numeral('00000')" :class="column.class" class="truncate"><strong>#{{ item[column.field] | numeral('00000') }}</strong></span>
                  <span v-if="column.dataType === 'number'" v-b-tooltip.hover :title="item[column.field] | numeral('0,0.00')" :class="column.class" class="truncate">{{ item[column.field] | numeral('0,0.00') }}</span>
                  <span v-if="column.dataType === 'date'" v-b-tooltip.hover :title="item[column.field] | moment-date-year-hour-min" :class="column.class" class="truncate">{{ item[column.field] | moment-date-year-hour-min }}</span>
                  <span v-if="column.dataType === 'currency'" v-b-tooltip.hover :title="item[column.field] | numeral('0,0.00')" :class="column.class" class="truncate">R${{ item[column.field] | numeral('0,0.00') }}</span>
                  <span v-if="column.dataType === 'percentage'" v-b-tooltip.hover :title="item[column.field] | numeral('0,0.00')" :class="column.class" class="truncate">{{ item[column.field] | numeral('0,0.00') }}%</span>
                  <button-component
                    v-if="column.dataType === 'button'"
                    :data="item"
                    :type="'primary'"
                    :size="'max'"
                    :square="true"
                    :withIcon="true"
                    :iconName="'icon-comment-1'"
                    @functionOutput="getFunctionOutput($event)"
                  />
                  <status-card-component
                    v-if="item.installment && column.dataType === 'tag'"
                    :label="new Date() > new Date(item.installment.pixDateExpire) ? 'PIX expirado' : item.installment.pix ? 'Aguardando PIX' : ''"
                    :type="new Date() > new Date(item.installment.pixDateExpire) ? 'danger' : item.installment.pix ? 'warning' : ''"
                    :size="'mid'"
                    :truncate="true"
                  />
                  <div v-else-if="column.dataType === 'tag'" class="status">
                    <status-card-component
                      :label="item.currentStep"
                      :type="item.currentStep === 'Criado' ? 'primary' : item.currentStep === 'Abandonado' ? 'warning' : 'disable'"
                      :size="'mid'"
                      :truncate="true"
                    />
                    <b-badge v-if="item.serviceStatus && item.sellerName !== 'Cvc'" pill :variant="(item.serviceStatus === 'Link criado') ? 'warning' : ((item.serviceStatus === 'Documentos enviados') ? 'success' : (item.serviceStatus === 'Resposta cliente') ? 'danger' : 'info')">
                      {{ item.serviceStatus }}
                    </b-badge>
                  </div>
                  <span v-if="column.dataType === 'phone'" v-b-tooltip.hover :title="item[column.field] | filterPhone" :class="column.class" class="truncate">{{ item[column.field] | filterPhone }}</span>
                  <span v-if="column.dataType === 'cnpj'" v-b-tooltip.hover :title="item[column.field] | filterCNPJ" :class="column.class" class="truncate">{{ item[column.field] | filterCNPJ }}</span>
                  <span v-if="column.dataType === 'cpf'" v-b-tooltip.hover :title="item[column.field] | filterCPF" :class="column.class" class="truncate">{{ item[column.field] | filterCPF }}</span>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div class="table-footer">
          <div class="number-of-results" v-if="data">{{data.length}} resultados de {{totalListItems}}</div>
          <button-component
            v-if="data"
            style="margin: 0 auto;"
            :data="{}"
            :label="loading ? '' : 'Carregar mais'"
            :square="loading ? true : false"
            :type="totalListItems <= data.length ? 'disable' : 'primary'"
            :loading="loading ? true : false"
            :size="'max'"
            :funcionInput="handleLoadMore"
            @functionOutput="getFunctionHandleLoadMore($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Button from './Button.vue'
import StatusCard from './StatusCard.vue'
export default {
  data () {
    return {
      openAccordion: false,
      columnSize: '',
      loadMore: 0
    }
  },
  mounted () {
    this.calculateColumnSizes()
  },
  destroyed () {},
  beforeDestroy () {},
  methods: {
    calculateColumnSizes () {
      this.columnSize = `width: ${100 / this.columns.length}%;`
    },
    onOpenAccordion () {
      this.openAccordion = !this.openAccordion
    },
    getFunctionOpenAccordion (event) {
      this.onOpenAccordion()
    },
    getFunctionOutput (event) {
      this.lineActive(event.id)
      this.$emit('functionOutput', event)
    },
    handleLoadMore () {
      this.$emit('emit-loading')
      this.loadMore += 10
    },
    getFunctionHandleLoadMore () {
      this.handleLoadMore()
      this.$emit('handleLoadMore', [this.loadMore, true])
    },
    lineActive (id) {
      this.$emit('lineActive', id)
    }
  },
  computed: {},
  components: {
    'button-component': Button,
    'status-card-component': StatusCard
  },
  filters: {
    filterCNPJ: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    },
    filterCPF: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    },
    filterPhone: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})/, '($1) $2 $3-$4')
    }
  },
  props: {
    title: { type: String },
    data: { type: Array },
    columns: {
      type: Array,
      default: () => []
    },
    accordion: { type: Boolean },
    functionInput: { type: Function },
    loading: { type: Boolean },
    totalListItems: { type: Number },
    active: { type: Number }
  }
}
</script>
<style lang="scss" scoped>
.primary-color {
  color: #1c56e0;
}
.secondary-color {
  color: #4285f4;
}
.success-color {
  color: #41bd64;
}
.warning-color {
  color: #f09b1b;
}
.danger-color {
  color: #ba2129;
}

#table {
  .table-container {
    padding: 24px;
    margin-bottom: 24px;
    border-radius: 16px;
    background-color: #FFFFFF;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      h3 {
        margin: 0;
        padding: 0;
        color: #1c56e0;
      }
    }
    .body {
      .table-header {
        background-color: #E0E0E0;
        display: flex;
        padding: 0 4px;
        .table-header-item {
          display: flex;
          align-items: center;
          height: 32px;
          color: #666666;
          font-size: 11px;
          font-weight: 600;
        }
      }
      .table-body {
        color: #333333;
        .table-content {
          padding: 20px 8px;
          border-bottom: solid 1px #D2D2D2;
          .table-body-item {
            display: inline-flex;
            align-items: baseline;
            padding: 0 2px;
            font-size: 13px;
            .truncate {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              display: inline-block;
              max-width: 100%;
            }
            .buyer-rating {
              width: 16px;
              min-width: 16px;
              height: 16px;
              min-height: 16px;
              position: relative;
              top: -2px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #FFFFFF;
              font-size: 8px;
              background-color: #1c56e0;
              border-radius: 4px;
            }
            .status-card {
              position: relative;
              top: -2px;
            }
            a {
              display: flex;
            }
          }
          &.active {
            font-weight: 900;
            background-color: rgba(66, 133, 244, 0.1);
          }
          &:last-child {
            border: none;
          }
        }
        .no-items {
          text-align: center;
          margin: 20px 0;
        }
        .status {
          display: flex;
          flex-direction: column;
        }
      }
      .table-footer {
        display: flex;
        .number-of-results {
          position: absolute;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/order/components/Table.vue